import { render, staticRenderFns } from "./OrderSummarySection.vue?vue&type=template&id=1540498d&scoped=true&"
import script from "./OrderSummarySection.vue?vue&type=script&lang=js&"
export * from "./OrderSummarySection.vue?vue&type=script&lang=js&"
import style0 from "./OrderSummarySection.vue?vue&type=style&index=0&id=1540498d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1540498d",
  null
  
)

export default component.exports